module.exports = __webpack_public_path__ + "static/banner-shape-1-1-182cec1fa2e4e00dcc561d6ea88ff51f.png";